import {symbol} from '../path/shapes.js';
import {intersectPoint} from '../util/intersect.js';
import markItemPath from './markItemPath.js';

export default markItemPath('symbol', symbol, intersectPoint);
